<div class="relative flex h-full min-h-0 w-full grid-cols-1 flex-col">
  <div class="bg-theme-secondary-gray-background h-fit rounded-t-lg">
    <table class="w-full table-auto" #headerTable></table>
  </div>
  <div class="h-full min-w-0 overflow-y-auto">
    <table #bodyTable class="w-full table-auto">
      <tbody>
        <ng-content select="shared-core-table-header"></ng-content>
        <ng-content select="shared-core-table-body"></ng-content>
      </tbody>
    </table>
  </div>
</div>
